import { generateTestId } from "@client-shared";

export const setModalNavigationTestId = (identifier: string): string => generateTestId("ModalNavigation", identifier);

export const setModalNavigationBackButtonTestId = (identifier: string): string => generateTestId("ModalNavigationBackButton", identifier);

export const setModalNavigationContinueButtonTestId = (identifier: string): string =>
  generateTestId("ModalNavigationContinueButton", identifier);

export const setModalNavigationImportButtonTestId = (identifier: string): string =>
  generateTestId("ModalNavigationImportButton", identifier);
